<template>
  <div class="ai-designer col column dg-media">
    <div
      class="column col fragment-editor-cmp dg-content-center dg-items-center"
    >
      <q-scroll-area class="preview" :style="{ width: width + 'px' }">
        <ab-flow-components-renderer
          :key="upKey"
          :items="renderItems"
          :preview-mode="true"
        />
      </q-scroll-area>
    </div>
    <div>
      <q-input v-model="prompt" title="Prompt" placeholder="Enter prompt">
        <template v-slot:append>
          <q-btn
            v-if="fragmentSource"
            label="Modify"
            flat
            color="primary"
            icon="draw"
            @click="generateCode(true)"
          />
          <q-btn
            label="Generate"
            flat
            color="primary"
            icon="draw"
            @click="generateCode(false)"
          />
          <q-btn
            v-if="isGenerated && fragmentSource"
            label="Save"
            flat
            color="accent"
            icon="save"
            @click="saveCode"
          />
        </template>
      </q-input>
    </div>
  </div>
</template>

<script>
import AbFlowComponentsRenderer from "ab-flow-designer/src/components/Designer/AbFlowComponentsRenderer";

export default {
  name: "AiDesignGenerator",
  components: { AbFlowComponentsRenderer },
  props: {
    width: {
      type: Number,
      default: 400,
    },
    block: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    prompt: "",
    fragmentSource: null,
    upKey: 0,
    isGenerated: false,
  }),
  created() {
    this.fragmentSource = this.block;
  },

  computed: {
    renderItems() {
      return ["Fragment"].includes(this.fragmentSource?.type)
        ? this.fragmentSource?.children
        : [this.fragmentSource];
    },
  },

  methods: {
    /**
     * Save code
     */
    saveCode() {
      //this.$emit('update:modelValue', this.fragmentSource)
      // this.$emit("close");
      // Set block children
      Object.assign(this.mutate(this.block), this.fragmentSource);
    },

    /**
     * Call controller method that will generate json code according to prompt
     * and return new json schema to be placed as fragment source
     */
    async generateCode(modify = false) {
      // Set loading
      this.generationInProgress = true;

      try {
        // Show loading
        this.$q.loading.show();

        // Call controller method
        const code = await this.app.client.call(
          "ai-designer",
          "generateDesign",
          this.block.type === "Fragment" ? "fragment" : "container",
          modify ? this.fragmentSource : "",
          this.prompt,
        );

        if (code) {
          this.fragmentSource = {
            ...this.block,
            children: code?.children || []
          }
        } else {
          this.$q.notify({
            message: "No code generated",
            color: "negative",
            position: "top",
          });
        }

        // Update key
        this.upKey++;
        this.isGenerated = true;
      } catch (ex) {
        console.error(ex);
      } finally {
        // Hide loading
        this.$q.loading.hide();
      }

      // Reset loading
      this.generationInProgress = false;

      // Reset prompt
      //this.prompt = ''
    },
  },
};
</script>

<style lang="scss">
.ai-designer {
  .preview {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 10px;
    height: 100%;
  }
}
</style>
